// extracted by mini-css-extract-plugin
export default {"Paper":"SUEKEducations_Paper__isEPX","TableRow":"SUEKEducations_TableRow__4yeD5"};